/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateTeamsCardNotificationsRequest
 */
export interface CreateTeamsCardNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTeamsCardNotificationsRequest
     */
    'channelId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTeamsCardNotificationsRequest
     */
    'transactionTypes': Array<CreateTeamsCardNotificationsRequestTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof CreateTeamsCardNotificationsRequest
     */
    'largeAmountThreshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTeamsCardNotificationsRequest
     */
    'userAccountIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTeamsCardNotificationsRequest
     */
    'groupIds': Array<string>;
}

export const CreateTeamsCardNotificationsRequestTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type CreateTeamsCardNotificationsRequestTransactionTypesEnum = typeof CreateTeamsCardNotificationsRequestTransactionTypesEnum[keyof typeof CreateTeamsCardNotificationsRequestTransactionTypesEnum];


